/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

// @ts-expect-error Could not find a declaration file for module
import WizardNoResultsError from '../../../components/Errors/WizardNoResultsError';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect, useMemo } from 'react';
import { UserAttributeKeys } from '../../../features/userAttributes';
import { useUserAttribute } from '../../../features/userAttributes/userAttributesQueries';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import Raven from 'raven-js';
import { useHistory } from 'react-router-dom';
import { useSearchFeedback } from '../../search';
import { LearningContentCard } from '../../cards';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import UsageTracker from '../../../utils/UsageTracker';
import ResponsiveCardGridContainer from '../../../components/ResponsiveCardGridContainer';
import { WIZARD_PAGE_SIZE } from '../wizardConsts';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useSearchState } from '../../search/searchStore';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useWizardProgress } from '../wizardQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const useWizardLoginRedirect = () => {
  const history = useHistory();
  const [[loginRedirectUrl]] = useSearchParam('loginRedirectUrl');
  return useMemo(() => {
    if (!loginRedirectUrl || !loginRedirectUrl.length) return false;
    try {
      const {
        pathname,
        search
      } = new URL(loginRedirectUrl);
      // redirects to login redirect url after updating learning interest
      // removes the base path from the absolute url (if existing) for a better experience
      const newPath = pathname.replace(/academy\/([0-9]+\/)?/, '');
      history.replace({
        pathname: newPath,
        search
      });
      return true;
    } catch (_unused) {
      Raven.captureMessage(`Wizard: error redirecting to loginRedirectUrl`, {
        extra: {
          loginRedirectUrl
        }
      });
    }
    return false;
  }, [history, loginRedirectUrl]);
};
const useWizardResults = results => {
  return useLearningContentCardModels({
    items: (results === null || results === void 0 ? void 0 : results.map(item => {
      const {
        id,
        contentType
      } = item;
      return {
        id: id,
        type: contentType === 'TEMPLATE' || contentType === 'EBOOK' ? 'LESSON' : contentType,
        language: 'language' in item ? item.language : undefined,
        resultMLOptionId: item.resultMLOptionId
      };
    })) || [],
    skip: !(results !== null && results !== void 0 && results.length)
  });
};
export const WizardResults = ({
  catalogUrl,
  isRequesting,
  onOpenResultsClick,
  results,
  totalResultCount,
  correlationId
}) => {
  const {
    setLastClickedSearchResultItem
  } = useSearchState();
  const [sendSearchFeedback] = useSearchFeedback();
  const isRedirecting = useWizardLoginRedirect();
  const {
    isMobile
  } = useMediaQuery();
  const noResultsExist = () => !(results !== null && results !== void 0 && results.length);
  const {
    setUserAttribute
  } = useUserAttribute(UserAttributeKeys.WIZARD_COMPLETION_DATE);
  const {
    cardModels,
    cardModelsLoading
  } = useWizardResults(results);
  const {
    currentStep
  } = useWizardProgress();
  const isFinalStep = currentStep === 'final';
  const trackCatalogLinkClick = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-view-results-on-catalog',
      location: 'results page link'
    });
  };
  const renderResultsLink = () => {
    return /*#__PURE__*/_jsx(View, {
      display: isMobile ? 'block' : 'inline-block',
      textAlign: isMobile ? 'center' : undefined,
      children: /*#__PURE__*/_jsx(RouterLink, {
        onClick: trackCatalogLinkClick,
        to: catalogUrl,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.wizard.modal.stepfinal.resultslink",
          options: {
            resultsCount: totalResultCount
          }
        })
      })
    });
  };
  const renderError = () => {
    return /*#__PURE__*/_jsxs(View, {
      paddingBlockStart: isMobile ? '0' : '1000',
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(WizardNoResultsError, {}), isMobile && /*#__PURE__*/_jsx(Button, {
        onClick: onOpenResultsClick,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.wizard.modal.stepfinal.openresults"
        })
      })]
    });
  };
  const renderLoadingState = () => {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered",
      size: "medium"
    });
  };
  useEffect(() => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-view-results'
    });
  }, []);
  useEffect(() => {
    setUserAttribute(Date.now());
  }, [setUserAttribute]);
  const handleOnItemClick = ({
    id,
    type,
    language,
    resultMLOptionId
  }, position) => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-result-card',
      contentType: type
    });
    setLastClickedSearchResultItem({
      item: {
        id,
        type: type,
        language: language
      },
      position
    });
    if (correlationId) sendSearchFeedback({
      variables: {
        correlationId,
        contentContainerType: type,
        resultMLOptionId
      }
    }).catch(Raven.captureException.bind(Raven));
  };
  return isRequesting || cardModelsLoading || isRedirecting ? renderLoadingState() : noResultsExist() ? renderError() : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ResponsiveCardGridContainer, {
      className: 'noBorder',
      columnSize: 200,
      columns: isMobile ? 1 : 3,
      maxInlineSize: 314,
      nowrap: !isMobile,
      scrollOnMobile: !isMobile,
      children: cardModels === null || cardModels === void 0 ? void 0 : cardModels.map((item, index) => /*#__PURE__*/_jsx(LearningContentCard, {
        extraTrackingInfo: {
          source: 'searchV2'
        },
        item: item,
        onItemClick: () => handleOnItemClick(item, index + 1),
        overviewType: "wizard-results",
        position: index + 1,
        size: isMobile ? 'small' : 'large'
      }, `item_${item.id}`))
    }), totalResultCount > WIZARD_PAGE_SIZE && renderResultsLink(), isFinalStep && totalResultCount > 0 && /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "400",
      textAlign: isMobile ? 'center' : 'left',
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.wizard.modal.refineresults"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.wizard.modal.savecourses"
      })]
    })]
  });
};
export default WizardResults;